export const LADE_AUSWAHLWERTE_AUFTRAG = "ladeAuswahlwerteAuftrag";